/**
 * 【架构列表】
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XOKButton } from '@/components/xqxc_ui';
import model from '@/reducers/permissions/structure/model';
import { connect } from 'react-redux';
import TableContent from './components/TableContent';
import Operate from './operate';
import Delete from './delete';

class Dept extends React.Component {

    state = {
        openModalType: '', // 弹框类型
        openModalParam: undefined, // 弹框入参 
    };

    componentDidMount() {
        this.props.getDeptList();
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.props.getDeptList({ pageSize, pageNum });
    }

    // 表格操作
    _tableAction = (type, item) => {
        switch (type) {
            case 'new':
                this.setState({ openModalType: 'new', openModalParam: undefined });
                break;
            case 'edit':
                this.setState({ openModalType: 'edit', openModalParam: item });
                break;
            case 'delete':
                this.setState({ openModalType: 'delete', openModalParam: item });
                break;
        }
    }

    //打开弹窗
    _renderMode = () => {
        switch (this.state.openModalType) {
            case 'new':
                return <Operate title='新建部门' closeModal={this._closeModal} type='new' param={undefined} />;
            case 'edit':
                return <Operate title='编辑部门' closeModal={this._closeModal} type='edit' param={this.state.openModalParam} />;
            case 'delete':
                return <Delete title='删除部门' closeModal={this._closeModal} type='delete' param={this.state.openModalParam} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (updateSuccess) => {
        this.setState({ openModalType: '' });
        if (updateSuccess) {
            this.props.getDeptList();
        }
    }

    render() {
        return (
            <div className={styles.flexBoxContainer}>
                <div className={styles.row2}>
                    <XOKButton
                        style={{ width: '100px' }}
                        label='新建部门'
                        onClick={() => { this.setState({ openModalType: 'new' }); }}
                    />
                </div>
                <TableContent
                    renderData={this.props.deptList}
                    tableAction={this._tableAction}
                    paginationChange={this._paginationChange}
                />
                {this._renderMode()}
            </div>
        );
    }
}

Dept.propTypes = {
    history: PropTypes.object, // history router 
    addOneBreadcrumbPath: PropTypes.func, // 添加一个面包屑导航子级
    keepSecondNavBreadcrumb: PropTypes.func, // 保持两级面包屑导航
    getDeptList: PropTypes.func, // 获取部门列表
    deptList: PropTypes.array, // 部门列表
};

const mapStateToProps = (state) => ({
    deptList: state.structure.getDeptList,
});

export default connect(mapStateToProps, { ...model.actions })(Dept);